export enum ErrorActionTypes {
  DISPLAY_ERROR = '@@error/DISPLAY_ERROR',
  ACK_ERROR = '@@error/ACK_ERROR'
}

export interface ErrorStateTypes {
  showError: boolean
  errorText: string
}
